/** Import fallbacks that are not real colours (Color master "Standard", etc.). */
const PLACEHOLDER_KEYS = new Set([
  "standard",
  "nothing",
  "none",
  "n/a",
  "n-a",
  "na",
  "default",
  "unknown",
]);

export function isPlaceholderColor(color) {
  if (!color) return true;
  if (typeof color === "string") {
    return PLACEHOLDER_KEYS.has(color.toLowerCase().trim());
  }
  const slug = String(color.slug || "").toLowerCase().trim();
  const name = String(color.name || "").toLowerCase().trim();
  return PLACEHOLDER_KEYS.has(slug) || PLACEHOLDER_KEYS.has(name);
}
